export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    const { initializeAfterLogin, isInitialized } = useIntercomManager()
    const userStore = useUserStore()

    // Helper function to wait for page stability
    const waitForPageStability = async (): Promise<void> => {
      // Wait for next tick first
      await nextTick()

      // Wait for document to be ready
      if (document.readyState !== 'complete') {
        await new Promise<void>((resolve) => {
          const checkReadyState = () => {
            if (document.readyState === 'complete') {
              resolve()
            } else {
              setTimeout(checkReadyState, 50)
            }
          }
          checkReadyState()
        })
      }

      // Use requestIdleCallback if available, or fallback to a single animation frame
      await new Promise<void>((resolve) => {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(() => resolve(), { timeout: 1000 })
        } else {
          requestAnimationFrame(() => resolve())
        }
      })
    }

    // Watch for authentication state and initialize Intercom when user is authenticated
    // but only after page is fully stable
    watch(
      () => userStore.isAuthenticated,
      async (isAuthenticated) => {
        if (isAuthenticated && !isInitialized.value) {
          try {
            await waitForPageStability()
            await initializeAfterLogin()
          } catch {
            // Fail silently - errors will be shown when user tries to use chat
          }
        }
      },
      { immediate: true } // Check immediately in case user is already authenticated
    )
  }
})
